import ctaImage from "@/images/site/cta.jpg";
import Container from "./Container";
import CtaLink from "./CtaLink";
import Eyebrow from "./Eyebrow";
import { GET_STARTED_PATH } from "./nav";

const CtaBand = () => {
  return (
    <section className="relative isolate overflow-hidden bg-navy">
      <img
        src={ctaImage}
        alt=""
        className="absolute inset-y-0 right-0 -z-20 h-full w-full object-cover md:w-3/5 md:object-[center_35%]"
      />
      <div className="absolute inset-0 -z-10 bg-navy/80 md:bg-transparent md:bg-linear-to-r md:from-navy md:from-40% md:to-transparent" />
      <Container className="py-20 md:py-24">
        <div className="max-w-xl">
          <Eyebrow className="text-brand">Ready to buy sooner?</Eyebrow>
          <h2 className="mt-4 text-4xl leading-[1.1] font-bold tracking-tight text-white sm:text-5xl">
            Let’s make your <br className="hidden sm:block" />
            home goals a reality.
          </h2>
          <p className="mt-5 text-lg text-white/85">Find out if you’re eligible for a BuySooner Boost.</p>
          <CtaLink to={GET_STARTED_PATH} variant="brand" className="mt-8">
            Help me BuySooner
          </CtaLink>
        </div>
      </Container>
    </section>
  );
};

export default CtaBand;
